function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFAF20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 0a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm0 1a7 7 0 0 1 7 7A7 7 0 1 1 9 8a7 7 0 0 1 7-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 10.5a.5.5 0 0 1 .492.41L16 11v1a.5.5 0 0 1-.992.09L15 12v-1a.5.5 0 0 1 .5-.5zM15.5 3.5a.5.5 0 0 1 .492.41L16 4v1a.5.5 0 0 1-.992.09L15 5V4a.5.5 0 0 1 .5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 4.5a2 2 0 0 1 2 2 .5.5 0 1 1-1 0 1 1 0 1 0-1 1 2 2 0 1 1-2 2 .5.5 0 1 1 1 0 1 1 0 1 0 1.117-.993L15.5 8.5a2 2 0 0 1 0-4zM7.5 18.5a.5.5 0 0 1 .492.41L8 19v1a.5.5 0 0 1-.992.09L7 20v-1a.5.5 0 0 1 .5-.5zM7.5 11.5a.5.5 0 0 1 .492.41L8 12v1a.5.5 0 0 1-.992.09L7 13v-1a.5.5 0 0 1 .5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 12.5a2 2 0 0 1 2 2 .5.5 0 1 1-1 0 1 1 0 1 0-1 1 2 2 0 1 1-2 2 .5.5 0 1 1 1 0 1 1 0 1 0 1.117-.993L7.5 16.5a2 2 0 0 1 0-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 16a7.986 7.986 0 0 1 8.56-7.972.5.5 0 1 1-.067.997A6.986 6.986 0 0 0 1 16a7 7 0 0 0 7 7 6.985 6.985 0 0 0 6.975-7.493.5.5 0 0 1 .997-.067A7.985 7.985 0 0 1 8 24a8 8 0 0 1-8-8z"
}));

var SvgTransactionIcon = function SvgTransactionIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransactionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transaction_icon.8cf7fda6.svg";
export { ForwardRef as ReactComponent };